import { sendOtp, verifyOtp } from 'aster-foundation/core/astercore/auth/otp/redux/actions';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ButtonBase } from '../../../Common/Component/Forms';
import CustomModal from '../../../Common/Component/Modal/Modal';
import OTPInput from '../../../Common/Component/OTPInput';
import { errorHandling } from '../../../Common/Utility/common-utils';
import { sendEventToSmartLook } from '../../../Common/Utility/smartlook';

const OtpModal = ({
  otpPopUp,
  visaStatus,
  patientId,
  setOtpPopUp,
  reqParams,
  onSubmitClick,
  number,
  type,
  setShowMobileLink,
  showMobileLink,
  mobileWithCode,
}) => {
  const MAX_TIME_OUT_OTP = 3;
  const RESET_OTP = 0;

  const dispatch = useDispatch();

  const [minutes, setMinutes] = useState(MAX_TIME_OUT_OTP);
  const [seconds, setSeconds] = useState(RESET_OTP);
  const [otherNumber, setOthernumber] = useState('');
  const [otpFailed, setOtpFailed] = useState(null);
  const [isInvalidOtp, setisInvalidOtp] = useState(false);
  const [otp, setOtp] = useState('');
  const [resetEnabled, setResetEnabled] = useState(false);

  useEffect(() => {
    if (resetEnabled) {
      toast.error('Timed out OTP !!');
    }
  }, [resetEnabled]);

  const sendOTP = (num) => {
    const params = {
      patientId,
      phoneNumber: num,
      email: '',
    };
    dispatch(
      sendOtp({
        params,
        onSuccess: () => {
          toast.success('Otp sent successfully');
        },
        onFailure: (err) => {
          errorHandling(err);
        },
      }),
    );
  };

  useEffect(() => {
    if (number || mobileWithCode) {
      setOthernumber(number);
      sendOTP(showMobileLink ? number : mobileWithCode);
    }
  }, [number]);

  useEffect(() => {
    if (otpPopUp) {
      const myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds((sec) => sec - 1);
        }
        if (seconds === 0) {
          if (minutes === 0) {
            setResetEnabled(true);
            clearInterval(myInterval);
          } else {
            setMinutes((min) => min - 1);
            setSeconds(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(myInterval);
      };
    }
    return null;
  }, [minutes, seconds]);

  const onNotAccessibleClick = (val) => {
    setOtpPopUp(false);
    reqParams?.telecom?.push({
      system: 'other',
      value: otherNumber,
    });
    reqParams?.extension?.push({
      url: 'alternateMobileVerficationStatus',
      valueString: val,
    });
    onSubmitClick(reqParams, !val);
  };

  const verifyOTP = (otpnum) => {
    const params = {
      code: Buffer.from(`code=${otpnum}&&PatientId=${patientId}`).toString('base64'),
    };
    dispatch(
      verifyOtp({
        params,
        onSuccess: (res) => {
          if (!res.verified) {
            toast.error(`OTP doesn't match`);
            setOtpFailed(true);
            setOtp('');
            sendEventToSmartLook('otp_error', 'otp_error');
          } else {
            sendEventToSmartLook('verify_otp', 'verify_otp');
            toast.success('Otp Verified successfully');
            onNotAccessibleClick(true);
          }
        },
        onFailure: (err) => {
          errorHandling(err);
        },
      }),
    );
  };

  const modalTitle =
    type !== 'edit'
      ? `This ${
          visaStatus === 'emiratesID' ? 'EID' : 'passport'
        } is linked to another mobile number. OTP will be send to....`
      : 'We have sent 6-Digit code on';
  const timer = `${`0${minutes.toString()}`}:${seconds < 10 ? `0${seconds.toString()}` : seconds}`;

  const onResendClick = () => {
    if (resetEnabled) {
      setMinutes(MAX_TIME_OUT_OTP);
      setSeconds(RESET_OTP);
      setResetEnabled(false);
      if (showMobileLink) {
        sendOTP(otherNumber);
      } else {
        sendOTP(mobileWithCode);
      }
    }
    sendEventToSmartLook('resend_otp', 'resend_otp');
  };

  const onContinueClick = (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      setisInvalidOtp(true);
    } else {
      setisInvalidOtp(false);
      verifyOTP(otp);
    }
  };

  const handleClose = () => {
    setOtp('');
    setOtpPopUp(false);
    setMinutes(RESET_OTP);
    setSeconds(RESET_OTP);
    setShowMobileLink(false);
  };

  return (
    <CustomModal
      customClass="modalVerification"
      bodyTextCenter={false}
      footerBtnFullWidth={false}
      modalTitle="Verification"
      closeButton
      crossPressed={handleClose}
      noFooter
      size="md"
    >
      <Form onSubmit={onContinueClick}>
        <div className="title">{modalTitle}</div>
        <div className="phoneNumber">{showMobileLink ? otherNumber : mobileWithCode}</div>
        <div className="otpBox">
          <div className="otpTextBox">
            <OTPInput
              autoFocus
              isNumberInput
              length={6}
              className="otpContainer"
              inputClassName="inputField form-control"
              isInvalid={isInvalidOtp}
              onChangeOTP={(inputotp) => setOtp(inputotp)}
              onPasteOtp={(inputpastotp) => setOtp(inputpastotp)}
              resetOTP={otpFailed}
              setResetOTP={setOtpFailed}
              autoComplete="one-time-code"
              inputMode="numeric"
            />
          </div>
          <div className="otherDetails">
            <div className="timer">
              <p>{timer}</p>
            </div>
            <div className="reSend">
              Didn&apos;t receive?
              <a className={resetEnabled ? 'link enabled' : 'link'} onClick={onResendClick}>
                Resend
              </a>
            </div>
          </div>
        </div>
        <div className="w-100 d-flex flex-column justify-content-center">
          {type !== 'edit' ? (
            <ButtonBase
              data-test="button3"
              enableFullWidth
              size="sm"
              variant="link"
              text="Mobile Number Not Accessible"
              onClick={() => onNotAccessibleClick(false)}
            />
          ) : null}
          <fieldset disabled={otp.length !== 6}>
            <ButtonBase data-test="button4" enableFullWidth size="md" variant="primary" text="Continue" type="submit" />
          </fieldset>
        </div>
      </Form>
    </CustomModal>
  );
};

OtpModal.propTypes = {
  otpPopUp: PropTypes.bool.isRequired,
  visaStatus: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  setOtpPopUp: PropTypes.func.isRequired,
  reqParams: PropTypes.object.isRequired,
  onSubmitClick: PropTypes.func.isRequired,
  number: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  setShowMobileLink: PropTypes.func.isRequired,
  showMobileLink: PropTypes.bool.isRequired,
  mobileWithCode: PropTypes.string.isRequired,
};

export default OtpModal;
